<template>
  <div>
    <test-prediction v-if="showTest" ref="testPredictionRef" />
    <v-btn v-if="showTest" color="black" dark @click="handleTestClick"
      >Test</v-btn
    >
    <v-btn
      :disabled="
        !(versions && versions.length) || $store.state.nlp.trainingStatus
      "
      color="success"
      style="width: 120px"
      @click="train"
    >
      <v-progress-circular
        v-if="$store.state.nlp.trainingStatus"
        indeterminate
        color="white"
        :size="24"
      />
      {{ $store.state.nlp.trainingStatus ? "Training.." : "Train" }}
    </v-btn>
    <v-btn color="primary" @click="publish">Publish Version</v-btn>
  </div>
</template>

<script>
import TestPrediction from "./TestPrediction";
export default {
  name: "AppActions",
  props: {
    showTest: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    TestPrediction,
  },
  data() {
    return {};
  },
  computed: {
    versions() {
      return this.$store.state.nlp.versions;
    },
  },
  async mounted() {
    await this.getVersions();
  },
  methods: {
    async getVersions() {
      if (
        !this.versions ||
        !this.versions.length ||
        !this.versions.filter((v) => v.status === "ACTIVE").length
      ) {
        await this.$store.dispatch("nlp/versions/get", null);
      }
    },
    async train() {
      await this.$store.dispatch("nlp/versions/train");
    },
    async publish() {
      await this.$store.dispatch("nlp/apps/publish");
    },
    test() {},
    getActiveVersion() {
      const filter = this.versions.filter((v) => v.status === "ACTIVE");
      return filter.length ? filter[0] : null;
    },
    getTrainingStatus() {
      const activeVersion = this.getActiveVersion();
      if (activeVersion) {
        this.$store.dispatch("nlp/versions/train/status/get");
      }
    },
    handleTestClick() {
      this.$refs.testPredictionRef.toggleDrawer(true);
    },
  },
};
</script>

<style lang="css" scoped>
.botter-training-progress {
  width: 120px;
  position: absolute;
  margin-top: -60px;
  margin-left: 7px;
  border-radius: 3px;
}
</style>
